<template>

  <modalo
    :title="$t('Message')"
    type="small"
    @hideModal="hideModal()"
    :modaloWatch="() => message">
    
    <form id="email-form" v-on:submit.prevent="saveMessage(message)">
      
      <div
        v-if="candidatesWithoutEmail.length"
        class="alert alert-warning p-3 mb-4">
        <div class="mb-2">Alguns candidatos não possuem e-mails</div>
        <select-multiple-candidates
          v-model="candidatesWithoutEmail"
          :remove="false">
          </select-multiple-candidates>
      </div>
      
      <div class="form-group">
        <div
          v-if="candidatesWithEmail.length"
          class="row mb-1">
          <label class="col-sm-2 col-form-label">Para</label>
          <div class="col-sm-10">
            
            <div class="d-flex mb-1">
              <div class="flex-grow-1">
                <select-multiple-candidates
                  v-model="candidatesWithEmail"
                  :remove="false">
                  </select-multiple-candidates>
                <ValidateMessage :error="validateErrors.to" />
              </div>
              <div>
                <button type="button" class="btn btn-sm btn-light" @click="showBcc=!showBcc" v-if="!enableShowBcc">CC/BCC</button>
              </div>
            </div>

          </div>
        </div>

        <div class="row mb-1" v-if="showBcc">
          <label class="col-sm-2 col-form-label">CC</label>
            <div class="col-sm-10">
              <selectize-multiple-email v-model="message.cc" :opts="[]"></selectize-multiple-email>
              <ValidateMessage :error="validateErrors.cc" />
            </div>
        </div>

        <div class="row mb-1" v-if="showBcc">
          <label class="col-sm-2 col-form-label">BCC</label>
          <div class="col-sm-10">
            <selectize-multiple-email v-model="message.bcc" :opts="[]"></selectize-multiple-email>
            <ValidateMessage :error="validateErrors.bcc" />
          </div>
        </div>
      </div>

      <div class="input-group">
        <input class="form-control" :placeholder="$t('Subject')" v-model="message.subject">
        <div class="input-group-append">
          <templatemail-select
            @setTemplate="setTemplate">
            </templatemail-select>
        </div>
      </div>
      <ValidateMessage :error="validateErrors.subject" />

      <div class="form-group">
        <textarea-editable
          v-model="message.body"
          editor-model="html"
          :enable-link="true"
          :enable-img="true"
          :placeholder="$t('Message')">
          </textarea-editable>
        <ValidateMessage :error="validateErrors.body" />
      </div>

      <div>
        <input-media 
          v-model="message.attachments_media"
          :multiple="true"
          btClass="btn btn-sm btn-light">
          <i class="fas fa-paperclip" /> {{ $t('Attach') }}
          </input-media>
        <ValidateMessage :error="validateErrors.attachments_media" />
      </div>

      <hr>

      <div class="form-group">
        <div class="row">
          <label class="col-sm-3">{{ $t('Send when') }}:</label>
          <div class="col-sm-9">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="send_type"
                id="send_type1"
                value="immediately"
                v-model="message.send_type">
              <label class="form-check-label" for="send_type1">
                {{ $t('Immediately') }}
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="send_type"
                id="send_type2"
                value="schedule"
                v-model="message.send_type">
              <label class="form-check-label" for="send_type2">
                {{ $t('Schedule') }}
              </label>
            </div>
            <ValidateMessage :error="validateErrors.send_type" />

            <div
              class="mt-3"
              v-if="message.send_type === 'schedule'">
              <DelayForm
                v-model="message.send_at" />
              <ValidateMessage :error="validateErrors.send_at" />
            </div>

          </div>
        </div>
      </div>

    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="email-form"
          class="btn btn-primary"
          :disabled="!candidatesWithEmail.length">{{ $t('Send') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click.stop="hideModal()">{{ $t('Cancel') }}</button>  
      </div>
    </template>

  </modalo>

</template>

<script>
import TemplatemailSelect from '@/components/Parts/TemplatemailSelect'
import SelectizeMultipleEmail from '@/components/Fields/SelectizeMultipleEmail'
import InputMedia from '@/components/Fields/InputMedia'
import SelectMultipleCandidates from '@/components/Fields/SelectMultipleCandidates'
import DelayForm from '@/components/Parts/DelayForm'

export default {
  name: 'MassiveEmail',
  components: {
    SelectizeMultipleEmail,
    TemplatemailSelect,
    InputMedia,
    SelectMultipleCandidates,
    DelayForm
  },
  props: [
    'initEmail'
  ],
  data () {
    return {
      loading: false,
      validateErrors: false,
      message: this.defaultValues(this.initEmail),
      showBcc: false
    }
  },
  computed: {
    candidates () {
      return this.message.candidates || {}
    },
    candidatesWithEmail () {
      return this
      .candidates
      .filter(candidate => candidate.email)
    },
    candidatesWithoutEmail () {
      return this
      .candidates
      .filter(candidate => !candidate.email)
    },
    enableShowBcc () {
      return (this.message.cc && this.message.cc.length) || (this.message.bcc && this.message.bcc.length)
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
        send_type: 'immediately'
      }, values)
    },
    /*
    setTemplate
    */
    setTemplate (template) {
      this.$set(this.message, 'subject', template.subject)
      this.$set(this.message, 'body', template.body)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveMessage
    */
    saveMessage (message) {
      this.loading = true

      return this.$store.dispatch('validateCreateEmail', {
        'candidate_id': '66b21b1e6dbb1c0013131c27',
        'job_id': '66b21b1e6dbb1c0013131c27',
        'subject': message.subject,
        'body': message.body,
        'to': [{email: 'test@test.com', name: 'test'}],
        'cc': message.cc,
        'bbc': message.bbc,
        'send_type': message.send_type,
        'send_at': message.send_at,
        'attachments_media': message.attachments_media
      }).then(() => {
        return Promise.all(this.candidatesWithEmail.map(candidate => {
          return this.$store.dispatch('createEmail', {
            'candidate_id': candidate._id,
            'job_id': message.job_id,
            'subject': message.subject,
            'body': message.body,
            'to': [{email: candidate.email, name: candidate.name}],
            'cc': message.cc,
            'bbc': message.bbc,
            'send_type': message.send_type,
            'send_at': message.send_at,
            'attachments_media': message.attachments_media
          })
        })).finally(_ => {
          this.loading = false
          this.$emit('created', {})
        })
      })
      .catch(err => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MassiveEmail/MassiveEmail.vue